import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MainService} from 'src/app/Services/service.service';
import {displayModeType} from 'src/app/Adv/search-results/search-results.component';
import {PageEvent} from '@angular/material';
import {DTOAdvertisementEx} from 'src/app/api/LocalModels';
import * as moment from "moment";
import {DTOAdvertisement, ShowAdType} from "../../api/WickedApiClient";
import { ViewMode } from './../../../Services/advertisement.service';
import { AdvUserAdvertisementsComponent } from 'src/app/Adveristments/adv-user-advertisements/adv-user-advertisements.component';

@Component({
  selector: 'app-user-advertisements',
  templateUrl: './user-advertisements.component.html',
  styleUrls: ['./user-advertisements.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserAdvertisementsComponent extends AdvUserAdvertisementsComponent{
  public enableSubscription:boolean = false;

  constructor(public route: ActivatedRoute, public service: MainService) {
    super(route, service);
    this.enableSubscription = service.enableSubscription;
    service.pageName = "My Ads";
  }

  ngOnInit() {
    if (!this.service.userService.isDemo()) {
      this.viewMode=ViewMode.ACTIVE;
    }
    this.performSearch();
  }
  
  public performSearch() {
    this.currentUserId = this.service.userService.getUserId();
    this.service.advService.searchDataUserAdv.currentSearchRule.userId = this.currentUserId;
    this.service.advService.searchActionForUser(this.viewMode);
  }

  public getDate(card){
    return card.dateStart.format("MM/DD/YYYY hh:mm A");
  }

  public get length() {
    return this.service.advService.searchDataUserAdv.resultCount;
  }

  public get pageSize() {
    return this.service.advService.searchDataUserAdv.currentSearchRule.pageSize;
  }

  public get pageNumber() {
    return this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber;
  }
  
  public getAdvTitle(adv: DTOAdvertisementEx) {
    var tag = this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId ? "" : `[${adv.categoryCode}] `;
    return `${tag}${adv.title}`;
  }

  public advIsExpired(adv): boolean {
    return adv.dateStart.isSameOrBefore(moment().subtract(14, 'day'))
  }

  public getLocation(adv: DTOAdvertisementEx) {
    return adv.subRegionName + ", " + adv.regionShortName;
  }


  public hasAdvertismentImage(advertisment: DTOAdvertisement): boolean {
    return advertisment.images.length > 0;
  }

  showTip(e){
    e.stopPropagation();

    e.target.getElementsByClassName("textTip")[0].style.opacity = "1";
    setTimeout(function(){ 
      e.target.getElementsByClassName("textTip")[0].style.opacity = "0";
    }, 2000);
  }
}


